import { React, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import "markerjs2";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/free-solid-svg-icons";
import "@fortawesome/free-solid-svg-icons";
import { faArrowUp, faStar } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import "react-slick";
import "../../components/Bookmarks/Bookmarks.scss";
import trashIcon from "../../assets/icons/Delete - Line icon.svg";
import filledIcon from "../../assets/icons/filled_icon.svg";
import sourceLink from "../../assets/icons/external_link_icon.svg";
import galleryIcon from "../../assets/icons/galleryIcon.svg";
import copyIcon from "../../assets/icons/copyIcon.svg";
import linkIcon from "../../assets/icons/cardLink.svg";
import shareIcon from "../../assets/icons/shareLink.svg";
import resizeIcon from "../../assets/icons/resizeIcon.svg";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import parse from "html-react-parser";
import CalenderIcon from "../../assets/icons/calendar.svg";
import EditIcon from "../../assets/icons/edit.svg";
import PreviousIcon from "../../assets/icons/Previous.svg";
import NextIcon from "../../assets/icons/Next.svg";
import FbIcon from "../../assets/images/fbnewlogo.svg";
import twitterlogo from "../../assets/images/twitternewlogo.svg";
import defaultUser from "../../assets/images/default-user.png";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";
import { toastify } from "../../components/Toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Paragraph";
import Paragraphs from "./Paragraphs";
// import DownloadButton from '../../assets/icons/orangeDownload.svg';
import DownloadButton from "../../assets/icons/blackDownload.svg";
import LandingPage from "../../assets/images/landingPage.png";
import PurpleLink from "../../assets/icons/purpleLink.svg";
import SliderPopup from "./Sliderpopup.js";
import ZimzeeIcon from "../../assets/icons/logoSymbol.svg";


// import resizeIcon from "../../assets/icons/resizeIcon.svg";

function CardDetail() {
  const [subBucket, setSubBucket] = useState([]);
  const [loadError, setLoadError] = useState("");
  const [code, setCode] = useState("Loading...");
  const [, setIsLoading] = useState(true);
  useState(false);
  const [popup, setPopup] = useState(false);
  const [bookmarkhandlePopup, setBookmarkhandlePopup] = useState(false);
  const [imageUrlPopup, setimageUrlPopup] = useState("");
  const [isEditorFocused, setIsEditorFocused] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPlayingPopup, setIsPlayingPopup] = useState(false);
  useState(0);
  const [isActive, setIsActive] = useState(false);
  const [, setReadOnly] = useState(true);
  const [, setEditorContent] = useState("");
  useState(false);
  const cardId = useParams();
  useState(null);
  useRef(null);
  const modules = {
    clipboard: {
      matchVisual: false,
    },
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        {
          color: [
            "#FF0000", // Red
            "#00FF00", // Green
            "#0000FF", // Blue
            "#FFFF00", // Yellow
            "#00FFFF", // Cyan
            "#FF00FF", // Magenta
            "#000000", // Black
            "#FFFFFF", // White
            "#808080", // Gray

            // Web-safe colors
            "#800000", // Maroon
            "#808000", // Olive
            "#000080", // Navy
            "#800080", // Purple
            "#008080", // Teal
            "#C0C0C0", // Silver
            // Shades of gray
            "#A9A9A9", // Dark gray
            "#696969", // Dim gray
            "#D3D3D3", // Light gray
            "#DCDCDC", // Gainsboro

            // Pastel colors
            "#FFB6C1", // Light pink
            "#90EE90", // Light green
            "#ADD8E6", // Light blue
            "#E6E6FA", // Lavender

            // CSS named colors
            "#FF6347", // Tomato
            "#F4A460", // Sandy Brown
            "#6495ED", // Cornflower Blue
            "#9932CC", // Dark Orchid
          ],
        },
      ],
      [
        {
          background: [
            "#FF0000", // Red
            "#00FF00", // Green
            "#0000FF", // Blue
            "#FFFF00", // Yellow
            "#00FFFF", // Cyan
            "#FF00FF", // Magenta
            "#000000", // Black
            "#FFFFFF", // White
            "#808080", // Gray

            // Web-safe colors
            "#800000", // Maroon
            "#808000", // Olive
            "#000080", // Navy
            "#800080", // Purple
            "#008080", // Teal
            "#C0C0C0", // Silver
            // Shades of gray
            "#A9A9A9", // Dark gray
            "#696969", // Dim gray
            "#D3D3D3", // Light gray
            "#DCDCDC", // Gainsboro

            // Pastel colors
            "#FFB6C1", // Light pink
            "#90EE90", // Light green
            "#ADD8E6", // Light blue
            "#E6E6FA", // Lavender

            // CSS named colors
            "#FF6347", // Tomato
            "#F4A460", // Sandy Brown
            "#6495ED", // Cornflower Blue
            "#9932CC", // Dark Orchid
          ],
        },
      ],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ];
  //   const initializeEditor = () => {
  //     if (imageRef.current) {
  //       const markerArea = new markerjs2.MarkerArea(imageRef.current); // Use Marker class from markerjs2
  //       markerArea.settings.displayMode = "popup";

  //       markerArea.addEventListener('render', event => {
  //         if (imageRef.current) {
  //             imageRef.current.src = event.dataUrl;
  //         }
  //       })
  //         markerArea.show();
  //     }
  //   };
  // Handle the "Edit" button click
  //   const handleEditClick = () => {
  //     if (editor) {
  //       editor.show();
  //     }
  //   };

  // Call initializeEditor when the component mounts

  useEffect(() => {
  }, [code]);
  let Link = Quill.import("formats/link");
  Link.sanitize = function (value) {
    value = typeof value === "string" ? value : String(value);
    let link = value.trim();
    if (!/^https?:\/\//i.test(link)) {
      link = `http://${link}`;
    }
    return link;
  };

  const handleProcedureContentChange = (content, delta, source, editor) => {
    if (delta && delta.ops) {
      delta.ops.forEach((op) => {
        if (op.insert && op.insert.link) {
          op.insert = Link.sanitize(op.insert.link);
        }
      });
    }

    // Set the updated content to the state
    setCode(content);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedHTML = clipboardData.getData("text/html");
    const quill = this.reactQuillRef.getEditor();
    const selection = quill.getSelection();
    const index = selection ? selection.index : 0;
    const delta = quill.clipboard.convert(pastedHTML);
    quill.updateContents(delta, Quill.sources.USER);
    quill.setSelection(index + delta.length(), Quill.sources.SILENT);
  };
  const handleKeyUp = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  //   const handleEditClick=()=>{
  //     handleEditorFocus()
  //   }
  //   const handleEditorFocus = () => {
  //     setReadOnly(false)
  //     setIsEditorFocused(true);
  //     setIsActive(true)
  //     const elements = document.getElementsByClassName('ql-toolbar');
  //     for (let i = 0; i < elements.length; i++) {
  //         elements[i].classList.add('my-class-selected');
  //       }
  //   };





  const handleEditorCancel = async () => {
    const token = localStorage.getItem("token");
    await axios
      .get(`${process.env.REACT_APP_API}cards/single-card/${cardId.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        setIsLoading(false);
        setSubBucket(response?.data?.data);
        setCode(response?.data?.data?.note ?? "Add Notes...");
        setIsEditorFocused(false);
        const elements = document.getElementsByClassName("ql-toolbar");
        for (let i = 0; i < elements.length; i++) {
          elements[i].classList.remove("my-class-selected");
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const handleChildClick = (event) => {
    event.stopPropagation();
  };





  const handlePopup = () => {
    setPopup(true);
    setIsPlayingPopup(false);
  };

  const handlePlayVideo = (event) => {
    // document.querySelector('video').play();
    if (isPlaying) {
      document.querySelector(".video-content-inner video").pause();
    } else {
      document.querySelector(".video-content-inner video").play();
    }
    setIsPlaying(!isPlaying);
    event.stopPropagation();
  };

  const handlePlayVideoPopup = (event) => {
    // document.querySelector('video').play();
    if (isPlayingPopup) {
      document.querySelector(".bucketCreationPopup video").pause();
    } else {
      document.querySelector(".bucketCreationPopup video").play();
    }
    setIsPlayingPopup(!isPlayingPopup);
    event.stopPropagation();
  };

  const handleImageClick = (imageUrl) => {
    setimageUrlPopup(imageUrl);
    setBookmarkhandlePopup(true);
  };

  function closePopup() {
    setPopup(false);
  }

  function closebookmarkPopup() {
    setBookmarkhandlePopup(false);
  }

  const handleClick = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };

  // let org_html = document.getElementsByClassName("x1n2onr6").innerHTML;
  // let new_html = "<div class='slidesInner'>" + org_html + "</div>";
  // document.getElementsByClassName("toggle-view-icon").innerHTML = new_html;

  // const element = document.getElementsByClassName('ql-picker-label');
  // if (element) {
  //     for (let i = 0; i < element.length; i++) {
  //         element[i].addEventListener('click', handleClick);
  //       }
  // //   element.addEventListener('click', handleClick);
  // }
  useEffect(() => {
    // Refetch for this route/refresh only; discard the previous request on cleanup.
    const controller = new AbortController();
    let active = true;
    setLoadError("");

    // api url

    const token = localStorage.getItem("token");
    axios
      .get(`${process.env.REACT_APP_API}cards/single-card/${cardId.id}`, { signal: controller.signal,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        if (!active) return;
        setIsLoading(false);
        const card = response?.data?.data;
        if (!card || typeof card !== 'object' || Array.isArray(card) || !card.content) throw new Error('Missing card data');
        setSubBucket({ ...card, content: { ...card.content, imageUrl: Array.isArray(card.content.imageUrl) ? card.content.imageUrl : [] } });
        setEditorContent(response?.data?.data?.content?.html);
        setCode(response?.data?.data?.note ?? "Add Notes...");
        const elements = document.getElementsByClassName("ql-toolbar");
        for (let i = 0; i < elements.length; i++) {
          elements[i].classList.add("my-class-selected");
        }
      })
      .catch(function (error) {
        if (!active) return;
        setLoadError("Unable to load this card. Please try again.");
      });

    return () => { active = false; controller.abort(); };
  }, [cardId.id]);

  const filterDropDown = [
    { name: "Date Swiped", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
    { name: "Manual", href: "#" },
  ];

  useState(filterDropDown[0].name);



  const updateCard = async (cardId) => {
    JSON.parse(localStorage.getItem("userData"));
    const token = localStorage.getItem("token");
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API}cards/update`,
        { cardId: cardId, note: code },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastify("success", response.data.message);
      setReadOnly(true);
      setIsEditorFocused(false);
      setIsActive(false);
      const elements = document.getElementsByClassName("ql-toolbar");
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove("my-class-selected");
      }
    } catch (error) {
      setIsActive(false);
      console.error(error);
      toastify("error", error.response.data.message);
    }
  };

  let videoIframe = "";
  let videoIframePopup = "";
  if (
    subBucket?.content?.imageUrl.length > 0 &&
    subBucket?.content?.imageUrl[0].urlType === "Video" &&
    subBucket?.content?.html &&
    subBucket?.content?.imageUrl[0].url
  ) {
    videoIframe = subBucket?.content?.html;
    const tempElement = document.createElement("div");
    tempElement.innerHTML = videoIframe;
    // tempElement.find('iframe').attr('')
    const iframes = tempElement.querySelector("iframe");
    if (iframes) {
      const videoElement = document.createElement("video");
      videoElement.controls = isPlaying ? true : false;
      // videoElement.autoplay = true;

      const sourceElement = document.createElement("source");
      sourceElement.src = subBucket?.content?.imageUrl[0].url;
      sourceElement.type = "video/mp4";

      videoElement.appendChild(sourceElement);
      const playIcon = document.createElement("div");
      playIcon.className = "play-icon";
      playIcon.innerHTML = "&#9658;";

      // Wrap the video element with a container div
      const videoContainer = document.createElement("div");
      videoContainer.className = "video-container";
      videoContainer.appendChild(videoElement);
      // videoContainer.appendChild(playIcon);

      // Replace the iframe with the video element
      iframes.parentNode.replaceChild(videoContainer, iframes);
      // const myTimeout = setTimeout(myStopFunction, 1000);

      //     function myStopFunction() {
      //         setIsVideoHeight(document.getElementsByTagName('video')[0].clientHeight);
      //     }
    }

    // Get the updated HTML content from the temporary container
    const updatedHtml = tempElement.innerHTML;
    videoIframe = updatedHtml;

    videoIframePopup = subBucket?.content?.html;
    const tempElementPopup = document.createElement("div");
    tempElementPopup.innerHTML = videoIframePopup;
    // tempElement.find('iframe').attr('')
    const iframesPopup = tempElementPopup.querySelector("iframe");
    if (iframesPopup) {
      const videoElementPopup = document.createElement("video");
      videoElementPopup.controls = isPlayingPopup ? true : false;
      // videoElement.autoplay = true;

      const sourceElementPopup = document.createElement("source");
      sourceElementPopup.src = subBucket?.content?.imageUrl[0].url;
      sourceElementPopup.type = "video/mp4";

      videoElementPopup.appendChild(sourceElementPopup);
      // Wrap the video element with a container div
      const videoContainerPopup = document.createElement("div");
      videoContainerPopup.className = "video-container";
      videoContainerPopup.appendChild(videoElementPopup);
      // videoContainer.appendChild(playIcon);

      // Replace the iframe with the video element
      iframesPopup.parentNode.replaceChild(videoContainerPopup, iframesPopup);
    }

    // Get the updated HTML content from the temporary container
    const updatedHtmlPopup = tempElementPopup.innerHTML;
    videoIframePopup = updatedHtmlPopup;
  }

  if (loadError) return <div role="alert">{loadError}</div>;
  return (
    <div className="carddetail cardDetailHolder editcard-detail">
      <div className="cards">
        <div className="card-header flex flex-col md:flex-row justify-start md:justify-between items-center w-full mb-3">
          <div className="post-detail-wrapper">
            <div className="post-detail-top">
              <div className="bucketNameTag">
                <p className="bucketname-textcontent">
                  <a href="/app/buckets">My Bucket</a>{" "}
                  <span className="uxtext-content">
                    {" "}  /{" "}
                    <a href={"/app/buckets/" + subBucket?.bucketId?._id}>
                      {subBucket?.bucketId?.name}
                    </a>
                  </span>{" "}
                  <span className="uxtext-content">
                    {" "}/{" "}
                    <a href={"/app/card-detail/" + subBucket?._id}>
                      {subBucket?.title}
                    </a>
                  </span>
                </p>
                <div className="titlebucket-content bucketName flex items-center">
                  <div className="flex">
                    <img
                      className="mr-[5px] inner-logo"
                      src={
                        subBucket?.cardType
                          ? subBucket.cardType === "twitter"
                            ? twitterlogo
                            : subBucket.cardType === "facebook" ||
                              subBucket.cardType === "Facebook"
                              ? FbIcon
                              : subBucket.cardType === "screenshoot"
                                ? ZimzeeIcon
                                : defaultUser
                          : ""
                      }
                      alt="Icon"
                    />
                    <h4 className="buckettitle-textcontent">
                      {subBucket?.title}
                    </h4>{" "}
                  </div>
                  <img
                    className="mr-[7px] next-icons"
                    src={PreviousIcon}
                    alt="PreviousIcon"
                  />
                  <img
                    className="ml-[7px] next-icons"
                    src={NextIcon}
                    alt="NextIcon"
                  />
                </div>
                <div className="display-content">
                  <ul className="flex flex-wrap items-center">
                    <li className="text-[14px] lg:text-[17px]">
                      <a className="flex items-center" href="/">
                        <img
                          src={CalenderIcon}
                          alt="calenderIcon"
                          className="w-[22px]"
                        />{" "}
                        <span className="createdtext-content pl-2">
                          Created{" "}
                          {moment(subBucket?.createdAt).format(
                            "MMM D, YYYY @ hh:mm A"
                          )}
                        </span>
                      </a>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="carddetail-endcard">
                <div className="sharedAction flex items-center">
                  <div className="flex">
                    <img
                      className="topinner-logo s"
                      src={
                        subBucket?.cardType
                          ? subBucket.cardType === "twitter"
                            ? twitterlogo
                            : subBucket.cardType === "facebook" ||
                              subBucket.cardType === "Facebook"
                              ? FbIcon
                              : subBucket.cardType === "screenshoot"
                                ? ZimzeeIcon
                                : defaultUser
                          : ""
                      }
                      alt="Icon"
                    />
                  </div>
                  <div className="bg-[#FFE6D6] flex items-center px-3 py-1 rounded-2xl">
                    <p className="publicytext-content">Publicly Shared</p>
                    <span className="bg-white rounded-[50%] p-1 ml-2">
                      <img src={copyIcon} alt="copy-icon" />
                    </span>
                  </div>
                  <div className="w-6 mx-2">
                    <img
                      className="cardicon-imgcontent"
                      src={linkIcon}
                      alt="link-icon"
                    />
                  </div>
                  <div className="w-7 mx-2">
                    <img
                      className="cardicon-imgcontent"
                      src={shareIcon}
                      alt="shareIcon"
                    />
                  </div>
                </div>
                <div>
                  <div className="inviteBtn">
                    <span data-former-link=""
                      style={{
                        filter:
                          "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                      }}
                      className="btn-invite rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg"

                    >
                      @ Invite People
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="post-detail-middle">
              <div className="cardHeaderContent">
                {/* <div className="bucketNameTag">
                            <p className="bucketname-textcontent">{subBucket?.bucketId?.name}</p>
                        </div> */}
                <div className="flex actionsHolder">
                  <div className="m-auto">
                    <span data-former-link=""  className="flex items-center">
                      <FontAwesomeIcon
                        className="transform rotate-45"
                        icon={faArrowUp}
                      />
                      <span className="actionicon-content pl-3">Move to</span>
                    </span>
                  </div>
                  <div>
                    <span data-former-link=""  className="flex items-center pl-[24px]">
                      <img
                        className="w-6 trash-icon"
                        src={trashIcon}
                        alt="trashIcon"
                      />
                      <span className="actionicon-content pl-3">Delete</span>
                    </span>
                  </div>
                  <div>
                    <span data-former-link=""  className="flex items-center pl-[24px]">
                      <img className="w-6" src={filledIcon} alt="copy-to" />
                      <span className="actionicon-content pl-3">Copy to</span>
                    </span>
                  </div>
                  <div className="m-auto">
                    <span data-former-link=""  className="flex items-center pl-[24px]">
                      <img className="w-5" src={sourceLink} alt="source-link" />
                      <span className="actionicon-content pl-3">
                        Original Link
                      </span>
                    </span>
                  </div>
                  <div>
                    <span data-former-link=""  className="flex items-center pl-[24px]">
                      <img src={galleryIcon} alt="" />
                      <span className="actionicon-content pl-3">
                        Image Link
                      </span>
                    </span>
                  </div>
                </div>

                {/* <div className="bucketName flex items-center">
                            <img className="mr-[7px] inner-logo" src={(subBucket?.cardType)? (subBucket.cardType == 'twitter' ?  twitterlogo : subBucket.cardType == 'facebook' || subBucket.cardType == 'Facebook' ? FbIcon : defaultUser):("")} alt="Icon"/>
                            <h4 className="bucketnametitle-content mr-[30px]">{subBucket?.title}</h4>
                            <img className="mr-[7px] next-icons" src={PreviousIcon} alt="PreviousIcon"/>
                            <img className="ml-[7px] next-icons" src={NextIcon} alt="NextIcon"/>
                        </div> */}
              </div>

              {/* <div className="backgroundcard-rightcontent bg-[#F7F7F7] px-3 py-4 flex items-center" onClick={handleCompare}>
                                        <a className="savetext-button rounded-full bg-[#55A46A] text-white sm:text-sm  md:text-md lg:text-lg mr-3 compare-btn-edit" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
  <path d="M24.9374 2.95635V22.2199C24.9274 22.2318 24.9118 22.2411 24.9074 22.2542C24.6188 23.1831 24.0891 23.576 23.1234 23.576H13.6912C13.6081 24.2825 13.4213 24.5542 12.9953 24.5492C12.8339 24.5416 12.6776 24.4902 12.5431 24.4005C12.2557 24.2131 12.2582 23.8921 12.2626 23.576H11.6555C11.4524 23.576 11.2501 23.5822 11.0477 23.576C10.5049 23.5554 10.1813 23.0019 10.4418 22.5391C10.5026 22.4246 10.5946 22.3296 10.7071 22.2652C10.8196 22.2007 10.9481 22.1694 11.0777 22.1749C11.4712 22.1749 11.8647 22.1749 12.2551 22.1749V16.1158H9.08128C9.15999 16.2008 9.21933 16.2607 9.2743 16.3251C9.52916 16.6255 9.51916 17.034 9.25056 17.2977C9.12282 17.4273 8.94888 17.5009 8.76689 17.5025C8.5849 17.504 8.40975 17.4332 8.27986 17.3058C7.79222 16.8352 7.31332 16.3563 6.84317 15.8691C6.72063 15.7496 6.64989 15.5867 6.64615 15.4156C6.64241 15.2445 6.70598 15.0787 6.82318 14.954C7.30541 14.4455 7.80096 13.9495 8.30984 13.4661C8.57657 13.2125 8.98509 13.2424 9.24681 13.4904C9.37505 13.6131 9.45172 13.78 9.46124 13.9572C9.47075 14.1344 9.41239 14.3086 9.29804 14.4443C9.23557 14.5205 9.16873 14.5904 9.0869 14.6822H12.2514V3.01631C12.2309 3.01106 12.21 3.0073 12.1889 3.00507C11.8385 3.00507 11.4874 3.00507 11.137 3.00507C10.6679 3.00507 10.3474 2.71148 10.3537 2.29422C10.3593 1.88695 10.676 1.6071 11.1333 1.60273C11.5049 1.60273 11.8772 1.60273 12.2451 1.60273C12.3394 0.88626 12.3426 0.880014 12.7805 0.618286H13.1552C13.5663 0.805681 13.7237 1.13799 13.6612 1.60023H13.961C17.0464 1.60023 20.1313 1.60023 23.2158 1.60023C24.0697 1.60023 24.6638 2.0556 24.893 2.87639C24.9046 2.9047 24.9195 2.93154 24.9374 2.95635ZM16.8706 10.4877C16.7732 10.5914 16.7114 10.6508 16.6558 10.7157C16.537 10.8473 16.4725 11.0191 16.4754 11.1964C16.4783 11.3736 16.5484 11.5432 16.6714 11.6708C16.7326 11.737 16.8064 11.7904 16.8884 11.8279C16.9705 11.8653 17.0591 11.8861 17.1493 11.889C17.2394 11.8919 17.3292 11.8769 17.4135 11.8448C17.4978 11.8127 17.5748 11.7642 17.6402 11.7021C18.1362 11.2298 18.6213 10.7457 19.0956 10.2497C19.1571 10.1886 19.2058 10.116 19.2391 10.0359C19.2724 9.95591 19.2895 9.87011 19.2895 9.78344C19.2895 9.69678 19.2724 9.61097 19.2391 9.53095C19.2058 9.45092 19.1571 9.37826 19.0956 9.31714C18.6226 8.822 18.1381 8.33769 17.6421 7.86421C17.5768 7.80201 17.4999 7.75337 17.4157 7.72112C17.3315 7.68886 17.2418 7.67363 17.1517 7.6763C17.0616 7.67898 16.9729 7.6995 16.8908 7.73669C16.8086 7.77387 16.7347 7.82698 16.6733 7.89294C16.5498 8.02019 16.4792 8.18953 16.4757 8.3668C16.4723 8.54406 16.5362 8.71604 16.6545 8.84803C16.7126 8.91612 16.7745 8.98046 16.8688 9.08415H13.6831V10.4877H16.8706Z" fill="white"/>
  <path d="M0.97998 3.64795C0.998095 3.39809 0.992473 3.14823 1.0387 2.90587C1.10894 2.54335 1.3016 2.21597 1.5844 1.97854C1.86721 1.7411 2.22299 1.60803 2.5922 1.6016C2.91139 1.59473 3.23059 1.59536 3.54978 1.6016C3.96393 1.60847 4.27063 1.91393 4.26876 2.30496C4.26688 2.69599 3.95955 2.99144 3.54104 3.00144C3.27681 3.00581 3.01196 3.00144 2.74711 3.00144C2.46727 3.00144 2.39981 3.06828 2.39793 3.34062C2.39606 3.61297 2.39793 3.87033 2.39793 4.13518C2.39169 4.56431 2.08561 4.87663 1.68708 4.87039C1.28856 4.86414 1.00497 4.55744 0.997471 4.13955C0.994347 3.97589 0.997471 3.81223 0.997471 3.6492L0.97998 3.64795Z" fill="white"/>
  <path d="M0.99714 21.5223C0.99714 21.3824 0.99714 21.2424 0.99714 21.1019C0.99714 20.6259 1.27636 20.3073 1.69237 20.3042C2.10839 20.3011 2.39823 20.6222 2.39948 21.1163C2.39948 21.3661 2.40322 21.616 2.39948 21.8658C2.3951 22.0801 2.49067 22.1825 2.70743 22.1782C2.98727 22.1744 3.26961 22.1732 3.5482 22.1782C3.96297 22.1857 4.2703 22.4905 4.26967 22.879C4.26905 23.2676 3.96235 23.5718 3.54695 23.5786C3.22776 23.5836 2.90856 23.5861 2.58937 23.5786C2.17142 23.5671 1.77374 23.3961 1.47797 23.1005C1.18221 22.805 1.01083 22.4075 0.999014 21.9895C0.994641 21.834 0.999014 21.6772 0.999014 21.5223H0.99714Z" fill="white"/>
  <path d="M7.30722 1.60042C7.6108 1.60042 7.91375 1.59667 8.21671 1.60042C8.63272 1.60667 8.94005 1.90338 8.94317 2.29441C8.94421 2.38804 8.92638 2.48093 8.89075 2.56754C8.85513 2.65414 8.80243 2.73269 8.73581 2.79849C8.66918 2.8643 8.58999 2.91602 8.50296 2.95058C8.41592 2.98514 8.32282 3.00182 8.2292 2.99963C7.61496 3.0063 7.00093 3.0063 6.38711 2.99963C6.29356 3.00172 6.20055 2.98503 6.11357 2.95053C6.02658 2.91604 5.94741 2.86444 5.88072 2.7988C5.81403 2.73316 5.76119 2.65481 5.72532 2.56839C5.68945 2.48197 5.67128 2.38922 5.67189 2.29565C5.67501 1.9065 5.98421 1.60854 6.39773 1.60167C6.70131 1.59667 7.00427 1.60042 7.30722 1.60042Z" fill="white"/>
  <path d="M0.994897 7.90707C0.994897 7.60411 0.990524 7.30053 0.994897 6.99758C1.00177 6.58469 1.30347 6.27736 1.6945 6.27673C2.08553 6.27611 2.39036 6.58344 2.39411 6.99695C2.40036 7.61078 2.40036 8.22481 2.39411 8.83904C2.39411 9.02459 2.3204 9.20254 2.1892 9.33374C2.058 9.46494 1.88005 9.53865 1.6945 9.53865C1.50896 9.53865 1.33101 9.46494 1.19981 9.33374C1.06861 9.20254 0.994897 9.02459 0.994897 8.83904C0.9899 8.52922 0.994897 8.21814 0.994897 7.90707Z" fill="white"/>
  <path d="M2.3972 12.5873C2.3972 12.8827 2.3972 13.1782 2.3972 13.4736C2.39283 13.9078 2.10174 14.2195 1.70259 14.2232C1.30344 14.227 0.99861 13.914 0.995487 13.4855C0.991739 12.8871 0.991739 12.2887 0.995487 11.6903C0.995487 11.2611 1.30219 10.9488 1.70196 10.9525C2.10174 10.9563 2.3922 11.268 2.39657 11.7021C2.3997 11.997 2.3972 12.2918 2.3972 12.5873Z" fill="white"/>
  <path d="M2.3972 17.287C2.3972 17.575 2.3972 17.8623 2.3972 18.1497C2.39283 18.5838 2.10049 18.8961 1.70134 18.8993C1.30219 18.9024 0.99861 18.5894 0.995487 18.1603C0.991739 17.5615 0.991739 16.9629 0.995487 16.3644C0.995487 15.9359 1.30281 15.6236 1.70259 15.6274C2.10236 15.6311 2.3897 15.9397 2.39595 16.3544C2.40095 16.6655 2.3972 16.9766 2.3972 17.287Z" fill="white"/>
  <path d="M7.30597 23.5759C7.00239 23.5759 6.69943 23.5796 6.39648 23.5759C5.98234 23.569 5.67438 23.2698 5.67189 22.8794C5.67136 22.7857 5.68962 22.6929 5.72559 22.6064C5.76156 22.5199 5.81451 22.4415 5.88131 22.3758C5.9481 22.3101 6.02739 22.2584 6.11448 22.2239C6.20157 22.1894 6.2947 22.1727 6.38836 22.1748C7.0026 22.169 7.61663 22.169 8.23045 22.1748C8.32399 22.1715 8.41724 22.187 8.50468 22.2204C8.59211 22.2538 8.67196 22.3044 8.73948 22.3692C8.80701 22.4341 8.86084 22.5118 8.89779 22.5978C8.93474 22.6838 8.95406 22.7763 8.95461 22.8699C8.95515 22.9635 8.93691 23.0562 8.90095 23.1427C8.865 23.2291 8.81208 23.3074 8.74531 23.373C8.67854 23.4386 8.59929 23.4901 8.51225 23.5246C8.4252 23.559 8.33214 23.5756 8.23857 23.5734C7.92749 23.5815 7.61642 23.5759 7.30597 23.5759Z" fill="white"/>
</svg> Edit/Compare</a>
                                        <a href="#" className="savetext-button rounded-full bg-[#55A46A] text-white sm:text-sm  md:text-md lg:text-lg compare-btn-edit" onClick={handleEditorCancel}><svg xmlns="http://www.w3.org/2000/svg" width="31" height="23" viewBox="0 0 31 23" fill="none">
  <path d="M30.9994 20.6112C30.9053 20.887 30.8427 21.1792 30.7111 21.4362C30.241 22.3583 29.4685 22.837 28.4391 22.9004H28.4101C20.1324 22.9004 11.8541 22.9004 3.57532 22.9004C2.99231 22.9011 2.42638 22.7036 1.97041 22.3403C1.51444 21.977 1.19552 21.4695 1.06598 20.9011C0.959436 20.4224 0.979022 19.9148 0.9375 19.3773H30.9994V20.6112Z" fill="white"/>
  <path d="M2.75757 0H29.2274V17.5912H2.75757V0ZM18.5954 2.87363L16.9024 2.38947C15.7273 6.51972 14.5584 10.6155 13.3856 14.7262L15.0778 15.208C16.2506 11.0942 17.414 7.01642 18.5954 2.87363ZM7.78407 8.78384L11.8344 12.842C12.2152 12.4628 12.6178 12.0586 13.0691 11.6159L10.2057 8.76425L13.0401 5.93998L11.8344 4.72801L7.78407 8.78384ZM24.1938 8.80812L20.1349 4.74055L18.9229 5.96113L21.7895 8.83084L18.9394 11.6473C19.3695 12.0774 19.7737 12.4801 20.1545 12.86C21.4926 11.5164 22.8573 10.1517 24.197 8.80812H24.1938Z" fill="white"/>
</svg> Markup</a>
                                    </div>              */}
            </div>
          </div>
        </div>
        <hr />
        {/* <div className="cardHeaderDetails flex pt-3">



                </div> */}
      </div>

      <div className="secondsection-content flex">
        <div className="cardData cardtextwhole-content w-2/3 width-50">
          <div className="cardHtmlnew-content">
            <div className="cardheader-text content card-header ">
              <div className="cardHeaderContents">
                <div className="titlebucket-content bucketName flex items-center">
                  <div className="flex">
                    <img
                      className="mr-[5px] inner-logo"
                      src={
                        subBucket?.cardType
                          ? subBucket.cardType === "twitter"
                            ? twitterlogo
                            : subBucket.cardType === "facebook" ||
                              subBucket.cardType === "Facebook"
                              ? FbIcon
                              : subBucket.cardType === "screenshoot"
                                ? ZimzeeIcon
                                : defaultUser
                          : ""
                      }
                      alt="Icon"
                    />
                    <h4 className="buckettitle-textcontent">
                      {subBucket?.title}
                    </h4>{" "}
                  </div>

                  <div className="bucketActions flex items-center">
                    {/* <span onClick={handlePopup}>
                                <img className="resizeicon-imgcontent" src={resizeIcon} />
                            </span> */}
                    <span>
                      <img
                        className="subbuckets-dark"
                        src={EditIcon}
                        alt="editIcon"
                      />
                    </span>
                    <span>
                      <FontAwesomeIcon
                        className="ml-[40px] text-[#989898]"
                        icon={faStar}
                      />
                      {/* <FontAwesomeIcon className="px-3 text-[#707070]" icon={faTrash} /> */}
                    </span>
                    <span onClick={handlePopup}>
                      <img alt="Open card preview"
                        className="resizeicons-imgcontent ml-[40px]"
                        src={resizeIcon}
                      />
                    </span>
                  </div>
                </div>
                {/* <div className="cardHeaderDetails">
                        <ul className="flex flex-wrap items-center">
                            <li className="pr-2 text-[15px]"><a className="flex items-center" href="/"><span className="createdbucket-content">Updated {moment(subBucket?.createdAt).format('MMM D, YYYY @ hh:mm A')}</span></a> </li>        
                        </ul>
                    </div> */}
              </div>
            </div>
            <div className="display-content">
              <ul className="flex flex-wrap items-center">
                <li className="text-[14px] lg:text-[17px]">
                  <a className="flex items-center" href="/">
                    <img
                      src={CalenderIcon}
                      alt="calenderIcon"
                      className="w-[22px]"
                    />{" "}
                    <span className="createdtext-content pl-2">
                      Last updated{" "}
                      {moment(subBucket?.createdAt).format(
                        "MMM D, YYYY @ hh:mm A"
                      )}
                    </span>
                  </a>{" "}
                </li>
              </ul>
            </div>
            {/* <div className="cardContent cardDetailContent" onClick={handlePopup}>  */}
            {/* <button onClick={handlePopup}>Open Modal</button> */}

            {/* <ReactQuill
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        value={editorContent}


                    />  */}
            {subBucket?.content ? (
              subBucket.content.imageUrl.length > 0 &&
                subBucket?.content?.imageUrl[0].urlType === "Image" &&
                subBucket.content.html ? (
                <div className="cardContent cardDetailContent">
                  <div className="cardImage w-full mt-6 atest">
                    {subBucket?.cardType ? (
                      subBucket.cardType === "twitter" ? (
                        parse(subBucket.content.html)
                      ) : subBucket.cardType === "facebook" ? (
                        subBucket?.content?.imageUrl[0].isAdLibrary ? (
                          <>
                            <div className="ad-lib-first-html">
                              {parse(subBucket.content.html)}
                            </div>
                          </>
                        ) : (
                          <div className="first-html">
                            <Paragraphs
                              text={subBucket.content.html}
                              maxLength={380}
                            />
                          </div>
                        )
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    <div className="container fb-image">
                      {subBucket?.content?.imageUrl.length > 0 &&
                        subBucket?.content?.imageUrl[0].urlType === "Image" ? (
                        <img
                          className="w-full dgdg"
                          src={subBucket?.content?.imageUrl[0].url}
                          alt="Card preview"
                          onClick={handlePopup}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {subBucket?.cardType ? (
                      subBucket.cardType === "twitter" ? (
                        ""
                      ) : subBucket.cardType === "facebook" ? (
                        subBucket?.content?.imageUrl[0].isAdLibrary ? (
                          <>
                            <div className="ad-lib-second-html">
                              {parse(subBucket.content.html)}
                            </div>
                          </>
                        ) : (
                          <div className="second-html">
                            {parse(subBucket.content.html)}
                          </div>
                        )
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : subBucket?.content?.imageUrl.length > 0 &&
                subBucket?.content?.imageUrl[0].urlType === "Video" &&
                subBucket?.content?.html === " " ? (
                <div
                  className={`cardContent cardDetailContent video video-content-inner ${isPlaying ? "active" : ""
                    }`}
                >
                  <Paragraphs text={subBucket?.content?.html} maxLength={380} />
                  {/* {parse(videoIframe)} */}
                  <div className="video-container">
                    {isPlaying ? (
                      <video controls>
                        <source
                          src={subBucket?.content?.imageUrl[0].url}
                        ></source>
                      </video>
                    ) : (
                      <video>
                        <source
                          src={subBucket?.content?.imageUrl[0].url}
                        ></source>
                      </video>
                    )}

                    {isPlaying ? (
                      // <FontAwesomeIcon className="ml-[40px] text-[#989898]" icon={faPause} style={{color:"#fff",fontSize:"40px"}}/>
                      ""
                    ) : subBucket?.content?.imageUrl[0]?.url ? (
                      <>
                        <div
                          className="toggle-view-icon-outer"
                          onClick={handlePlayVideo}
                        >
                          <div className="toggle-view-icon">
                            <FontAwesomeIcon
                              className="ml-[40px] text-[#989898]"
                              icon={faPlay}
                              style={{ color: "#111111b0", fontSize: "40px" }}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <FontAwesomeIcon icon="fa-solid fa-play" /> */}

                  {subBucket?.cardType ? (
                    subBucket.cardType === "twitter" ? (
                      ""
                    ) : subBucket.cardType === "facebook" ? (
                      <div className="second-html">
                        {parse(subBucket.content.html)}
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              ) : subBucket?.content?.imageUrl.length > 0 &&
                subBucket?.content?.imageUrl[0].urlType === "Video" &&
                subBucket.content.html ? (
                <div
                  className={`cardContent cardDetailContent video video-content-inner ${isPlaying ? "active" : ""
                    }`}
                >
                  {subBucket?.cardType ? (
                    subBucket.cardType === "twitter" ? (
                      parse(subBucket.content.html)
                    ) : subBucket.cardType === "facebook" ? (
                      subBucket?.content?.imageUrl[0].isAdLibrary ? (
                        <>
                          <div className="ad-lib-first-html">
                            {parse(subBucket.content.html)}
                          </div>
                        </>
                      ) : (
                        <Paragraphs
                          text={subBucket.content.html}
                          maxLength={380}
                        />
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {/* {parse(videoIframe)} */}
                  <div className="video-container">
                    {isPlaying ? (
                      <video controls>
                        <source
                          src={subBucket?.content?.imageUrl[0].url}
                        ></source>
                      </video>
                    ) : (
                      <video>
                        <source
                          src={subBucket?.content?.imageUrl[0].url}
                        ></source>
                      </video>
                    )}

                    {isPlaying ? (
                      // <FontAwesomeIcon className="ml-[40px] text-[#989898]" icon={faPause} style={{color:"#fff",fontSize:"40px"}}/>
                      ""
                    ) : subBucket?.content?.imageUrl[0]?.url ? (
                      <>
                        <div
                          className="toggle-view-icon-outer"
                          onClick={handlePlayVideo}
                        >
                          <div className="toggle-view-icon">
                            <FontAwesomeIcon
                              className="ml-[40px] text-[#989898]"
                              icon={faPlay}
                              style={{ color: "#111111b0", fontSize: "40px" }}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <FontAwesomeIcon icon="fa-solid fa-play" /> */}
                  {subBucket?.cardType ? (
                    subBucket.cardType === "twitter" ? (
                      ""
                    ) : subBucket.cardType === "facebook" ? (
                      subBucket?.content?.imageUrl[0].isAdLibrary ? (
                        <>
                          <div className="ad-lib-second-html">
                            {parse(subBucket.content.html)}
                          </div>
                        </>
                      ) : (
                        <div className="second-html">
                          {parse(subBucket.content.html)}
                        </div>
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              ) : subBucket.content.html ? (
                <div
                  className="cardContent cardDetailContent"
                  onClick={handlePopup}
                >
                  <Paragraphs text={subBucket.content.html} maxLength={380} />
                </div>
              ) : (
                <div
                  className="cardContent cardDetailContent"
                  onClick={handlePopup}
                >
                  <div className="container fb-image cardImage w-full mt-6 btest">
                    {subBucket?.content?.imageUrl.length > 0 ? (
                      <img
                        className="w-full"
                        src={subBucket?.content?.imageUrl[0].url}
                        alt="Card preview"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )
            ) : (
              ""
            )}

            {/* <p>Collect recurring payments and automate your subscription billing logic - from checkout to reconciliation. Adjust price structures, product bundles, discount management, and recovery processes to maximise revenue.</p>
                            <div className="cardImage w-full mt-6">
                                <img className="w-full" src={cardImage} alt="card-image" />
                            </div> */}
            {/* </div> */}

            {popup && (
              <div
                className="bucketCreationPopup relative !z-[999]"
                style={{ height: "100%" }}
                onClick={closePopup}
              >
                <form
                  className="addBucket relative w-[85%] md:w-[55%]"
                  onClick={handleChildClick}
                >
                  <span
                    onClick={closePopup}
                    className="absolute right-0 top-[7px] w-6 h-6 bg-[#FF6600] m-4 flex justify-center items-center rounded-full"
                    style={{ zIndex: 1 }}
                  >
                    <FontAwesomeIcon
                      className="cursor-pointer text-white text-[14px]"
                      icon={faClose}
                    />
                  </span>
                  {subBucket?.content ? (
                    subBucket.content.imageUrl.length > 0 &&
                      subBucket?.content?.imageUrl[0].urlType === "Image" &&
                      subBucket.content.html ? (
                      <div style={{ maxHeight: "100vh", overflow: "auto" }}>
                        {subBucket?.cardType ? (
                          subBucket.cardType === "twitter" ? (
                            parse(subBucket.content.html)
                          ) : subBucket.cardType === "facebook" ? (
                            <div className="first-html">
                              {/* {parse(subBucket.content.html)} */}
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {subBucket?.content?.imageUrl.length > 0 &&
                          subBucket?.content?.imageUrl[0].urlType === "Image" ? (
                          <img
                            className="w-full"
                            src={subBucket?.content?.imageUrl[0].url}
                            alt="Card preview"
                          />
                        ) : (
                          ""
                        )}
                        {subBucket?.cardType ? (
                          subBucket.cardType === "twitter" ? (
                            ""
                          ) : subBucket.cardType === "facebook" ? (
                            <div className="second-html">
                              {/* {parse(subBucket.content.html)} */}
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {/* {parse(subBucket.content.html)}
                                                    <img className="w-full" src={subBucket?.content?.imageUrl} alt="card-image" /> */}
                      </div>
                    ) : subBucket?.content?.imageUrl.length > 0 &&
                      subBucket?.content?.imageUrl[0].urlType === "Video" &&
                      subBucket.content.html ? (
                      <div style={{ maxHeight: "100vh", overflow: "auto" }}>
                        <div
                          className={`cardContent cardDetailContent video video-content-inner ${isPlayingPopup ? "active" : ""
                            }`}
                        >
                          {parse(videoIframePopup)}
                          {/* <Paragraph
                                                        text={videoIframe}
                                                        maxLength={380} /> */}

                          {isPlayingPopup ? (
                            // <FontAwesomeIcon className="ml-[40px] text-[#989898]" icon={faPause} style={{color:"#fff",fontSize:"40px"}}/>
                            ""
                          ) : subBucket?.content?.imageUrl[0]?.url ? (
                            <>
                              <div
                                className="toggle-view-icon-outer"
                                onClick={handlePlayVideoPopup}
                              >
                                <div className="toggle-view-icon">
                                  <FontAwesomeIcon
                                    className="ml-[40px] text-[#989898]"
                                    icon={faPlay}
                                    style={{
                                      color: "#111111b0",
                                      fontSize: "40px",
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : subBucket.content.html ? (
                      parse(subBucket.content.html)
                    ) : (
                      <div style={{ maxHeight: "100vh", overflow: "auto" }}>
                        {subBucket?.content?.imageUrl.length > 0 ? (
                          <img
                            className="w-full"
                            src={subBucket?.content?.imageUrl[0].url}
                            alt="Card preview"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    )
                  ) : (
                    ""
                  )}
                </form>
              </div>
            )}

            {/* <div className="backgroundcard-rightcontent bg-[#F7F7F7] px-3 py-4 flex items-center" onClick={handleClick}>
    {compare ?<><a className="savetext-button rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg" href="#" style={{filter : "drop-shadow(rgba(0, 0, 0, 0.16) 0px 10px 20px)"}} onClick={()=>updateCard(cardId.id)} >Save & Replace</a>
                                        <a href="#" className="canceltext-content ml-8" onClick={handleEditorCancel}>Save as a new card</a></>:<><a className="savetext-button rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg" href="#" style={{filter : "drop-shadow(rgba(0, 0, 0, 0.16) 0px 10px 20px)"}} onClick={()=>updateCard(cardId.id)} >Save</a>
                                        <a href="#" className="canceltext-content ml-8" onClick={handleEditorCancel}>Cancel</a></>}

                                    </div> */}
          </div>

          {/* <div>hi</div> */}
          <div className="flex">
            <div className="inviteBtn">
              <div
                className="btncard-invite rounded-full bg-[#FFFFFF] text-white sm:text-sm  md:text-md lg:text-lg"
                href="#"
              >
                <img
                  className="mr-2"
                  src={DownloadButton}
                  alt="downloadButton"
                />
                JPG
              </div>
            </div>
          </div>
          <br />
          <div className="flex">
            {subBucket?.content ? (
              subBucket.content.imageUrl.length > 1 &&
                subBucket?.content?.imageUrl[0].urlType === "Image" ? (
                <div>
                  <SliderPopup
                    images={subBucket.content.imageUrl}
                    handleImageClick={handleImageClick}
                  />
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )}

            {/* <div>
              <img
                className="floatingmenu-imgcontent"
                src={FloatingMenu}
                alt="FloatingMenu"
              />
            </div> */}
          </div>

          {bookmarkhandlePopup && (
            <div
              className="bucketCreationPopup relative !z-[999]"
              style={{ height: "100%" }}
              onClick={closebookmarkPopup}
            >
              <form
                className="addBucket relative w-[85%] md:w-[55%]"
                onClick={handleChildClick}
              >
                <span
                  onClick={closebookmarkPopup}
                  className="absolute right-0 top-[7px] w-6 h-6 bg-[#FF6600] m-4 flex justify-center items-center rounded-full"
                >
                  <FontAwesomeIcon
                    className="cursor-pointer text-white text-[14px]"
                    icon={faClose}
                  />
                </span>
                <img
                  className="bookmarkspopup-content"
                  src={imageUrlPopup}
                  alt="bookmarksPopup"
                />
              </form>
            </div>
          )}
        </div>
        <div className="rightSideCardDetail w-1/3 pl-[30px]">
          <div className="notesHolder">
            <div style={{ display: "inline-flex" }}>
              <h4 className="headingtext-content">Notes</h4>
              <span>
                <img
                  className="subbuckets-dark "
                  src={EditIcon}
                  alt="editIcon"
                  style={{
                    width: "17px",
                    marginLeft: "12px",
                    objectFit: "contain",
                    transform: "translateY(-2px)",
                  }}
                />
              </span>
            </div>
            <div
              className="border border-[#e5e5e5] dark:border-[#202F4F] border-1 rounded-md overflow-hidden"
              style={{ resize: "horizontal" }}
            >
              {/* {code.length === 0 ?   
                               <ReactQuill
                               theme="snow"
                               modules={modules}
                               formats={formats}
                               value={code}
                               onChange={handleProcedureContentChange}
                               onFocus={handleEditorFocus}
                               onClick={handleEditorClick}
                               // onBlur={()=>updateCard(cardId.id)}
                               onKeyUp={handleKeyUp}
                               onPaste={handlePaste}

                               />
                      :

                      */}

              <ReactQuill
                theme="snow"
                modules={modules}
                formats={formats}
                value={code}
                onChange={handleProcedureContentChange}
                onKeyUp={handleKeyUp}
                onPaste={handlePaste}
              />
              {/* } */}

              {/* <textarea className=" w-full p-3 !h-60 hover:outline-none" placeholder="Add Notes..." /> */}
              {isEditorFocused && (
                <div
                  className="backgroundcard-rightcontent bg-[#F7F7F7] px-3 py-4 flex items-center"
                  onClick={handleClick}
                >
                  <button type="button" data-former-link=""
                    className="savetext-button rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg"

                    style={{
                      filter: "drop-shadow(rgba(0, 0, 0, 0.16) 0px 10px 20px)",
                    }}
                    onClick={() => updateCard(cardId.id)}
                  >
                    Save
                  </button>
                  <button type="button" data-former-link=""

                    className="canceltext-content ml-8"
                    onClick={handleEditorCancel}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>
          <div
            className={`fullpageClick ${isActive ? "active" : ""}`}
            onClick={() => updateCard(cardId.id)}
          ></div>
          <div className="tags !border-0 tagspace-notecontent">
            <h4 className="headingtext-content">Tags</h4>
            <div className="tagsHolder">
              {subBucket?.tags?.map((tag) => (
                <p className="!pt-0 !pb-1">
                  <span className="tagname-textcontent">{tag.name}</span>
                  <span data-former-link="" className="pl-1" >
                    x
                  </span>
                </p>
              ))}
            </div>
            <p className="separatetext-content pl-3">
              *Separate tags with (,) or return key
            </p>
          </div>
          <div className="landingpage-content">Landing Page</div>
          <div className="flex">
            <div>
              <img
                className="landing-imgcontent"
                src={LandingPage}
                alt="LandingPage"
              />
            </div>
          </div>
          <div className="landing-cardcontent">
            <div className="purple-imgcontent">
              <img className="pr-2" src={PurpleLink} alt="PurpleLink" />
              https://landorandfitch.com/en
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default CardDetail;
